<ion-split-pane contentId="main">
    <ion-menu contentId="main" when="lg">
        <ion-content>
            <div class="mx-5 flex flex-col items-center border-b border-gray-200 pt-6 pb-4">
                <img ngSrc="assets/img/logo_sidemenu.png" width="728" height="421" priority alt="Latour &amp; Petit" class="h-auto w-full max-w-[160px]" />
                <div class="mt-4 h-px w-10 bg-gray-300" aria-hidden="true"></div>
                <p class="mt-3 text-sm font-semibold tracking-wide text-gray-700">L&amp;P FAST</p>
            </div>

            <nav class="px-3 pb-4" aria-label="Navigation principale">
                <h2 id="nav-section-crm" class="nav-section">CRM</h2>
                <ul class="space-y-1" aria-labelledby="nav-section-crm">
                    @for (item of crmItems; track item.link) {
                        <li><ng-container *ngTemplateOutlet="navLink; context: { $implicit: item }"></ng-container></li>
                    }
                    <li>
                        <button
                            type="button"
                            class="flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-800"
                            aria-haspopup="dialog"
                            (click)="openSupport()"
                        >
                            <fa-icon [icon]="faLifeRing" [fixedWidth]="true" class="text-[17px] leading-none" aria-hidden="true" />
                            Support
                        </button>
                    </li>
                </ul>

                @if (showManagement()) {
                    <h2 id="nav-section-management" class="nav-section">Management</h2>
                    <ul class="space-y-1" aria-labelledby="nav-section-management">
                        @for (group of managementGroups(); track group.label) {
                            <li>
                                <button
                                    type="button"
                                    class="nav-link flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-800 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent"
                                    [disabled]="group.disabled"
                                    [attr.aria-expanded]="openGroups().has(group.label)"
                                    [attr.aria-controls]="'nav-group-' + $index"
                                    (click)="toggleGroup(group.label)"
                                >
                                    <fa-icon [icon]="group.icon" [fixedWidth]="true" class="text-[17px] leading-none" aria-hidden="true" />
                                    <span class="flex-1">{{ group.label }}</span>
                                    <fa-icon
                                        [icon]="faChevronDown"
                                        class="text-[13px] leading-none transition-transform"
                                        [class.rotate-180]="openGroups().has(group.label)"
                                        aria-hidden="true"
                                    />
                                </button>
                                <ul
                                    [id]="'nav-group-' + $index"
                                    class="mt-1 ml-[22px] space-y-1 border-l border-gray-200 pl-2"
                                    [hidden]="!openGroups().has(group.label)"
                                >
                                    @for (item of group.items; track item.link) {
                                        <li><ng-container *ngTemplateOutlet="navLink; context: { $implicit: item }"></ng-container></li>
                                    }
                                </ul>
                            </li>
                        }
                    </ul>
                }

                @if (showAdministration()) {
                    <h2 id="nav-section-admin" class="nav-section">Administration</h2>
                    <ul class="space-y-1" aria-labelledby="nav-section-admin">
                        @for (item of adminItems(); track item.link) {
                            <li><ng-container *ngTemplateOutlet="navLink; context: { $implicit: item }"></ng-container></li>
                        }
                    </ul>
                }
            </nav>
        </ion-content>

        <ion-footer class="ion-no-border">
            <div class="border-t border-gray-200 bg-white p-4">
                <div class="flex items-center gap-3">
                    @if (profilePictureUrl(); as url) {
                        <img [src]="url" crossorigin="anonymous" alt="" width="36" height="36" class="size-9 shrink-0 rounded-full border border-gray-300 object-cover" />
                    } @else {
                        <span class="flex size-9 shrink-0 items-center justify-center rounded-full bg-secondary-600 text-sm font-semibold text-white" aria-hidden="true">
                            {{ initials() }}
                        </span>
                    }
                    @if (profile(); as p) {
                        <div class="min-w-0">
                            <p class="truncate text-sm font-medium text-gray-900">{{ p.firstName }} {{ p.lastName }}</p>
                            <p class="truncate text-xs text-gray-700">{{ p.email }}</p>
                        </div>
                    } @else {
                        <div class="flex min-w-0 flex-1 flex-col gap-1" role="status">
                            <span class="sr-only">Chargement du profil</span>
                            <div class="h-4 w-4/5 animate-pulse rounded-md bg-gray-200" aria-hidden="true"></div>
                            <div class="h-3 w-3/5 animate-pulse rounded-md bg-gray-200" aria-hidden="true"></div>
                        </div>
                    }
                </div>
                <button
                    type="button"
                    class="mt-4 w-full rounded-md px-3 py-2 text-sm font-medium text-gray-900 ring-1 ring-gray-300 hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-800"
                    (click)="logout()"
                >
                    Se déconnecter
                </button>
            </div>
        </ion-footer>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
</ion-split-pane>

<ng-template #navLink let-item>
    @if (item.disabled) {
        <span class="flex cursor-not-allowed items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 opacity-50" aria-disabled="true">
            @if (item.icon) {
                <fa-icon [icon]="item.icon" [fixedWidth]="true" class="text-[17px] leading-none" aria-hidden="true" />
            }
            {{ item.label }}
        </span>
    } @else {
        <a
            class="nav-link flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-800"
            [routerLink]="item.link"
            routerDirection="root"
            routerLinkActive="nav-link-active"
            ariaCurrentWhenActive="page"
            (click)="closeMenu()"
        >
            @if (item.icon) {
                <fa-icon [icon]="item.icon" [fixedWidth]="true" class="text-[17px] leading-none" aria-hidden="true" />
            }
            {{ item.label }}
        </a>
    }
</ng-template>


@if (modalOpen()) {
    <!-- modal container: focusable so key events bubble here for Escape handling -->
    <div
        class="fixed inset-0 z-50 flex items-center justify-center p-4"
        role="presentation"
        tabindex="0"
        (keydown)="onKeydown($event)"
        aria-hidden="false"
    >
        <!-- Backdrop: semi-transparent + blurred -->
        <div class="absolute inset-0 bg-black/40 backdrop-blur-sm" (click)="cancel()" aria-hidden="true"></div>

        <!-- Dialog panel (light mode only) -->
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="support-modal-title"
            class="relative w-full max-w-xl mx-auto bg-white rounded-lg shadow-xl ring-1 ring-black/5 overflow-hidden"
        >
            <!-- Header -->
            <div class="flex items-start justify-between p-4 border-b border-gray-100">
                <h2 id="support-modal-title" class="text-lg font-semibold text-gray-900">
                    Contacter le support
                </h2>
                <button
                    type="button"
                    (click)="cancel()"
                    class="ml-3 inline-flex items-center justify-center rounded-md p-2 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    aria-label="Close support dialog"
                >
                    <fa-icon [icon]="faXmark" class="text-[20px] leading-none" aria-hidden="true" />
                </button>
            </div>

            <!-- Body -->
            <div class="p-4 space-y-4 text-sm text-gray-700">
                <p class="sr-only">Dialog content: contact support</p>
                <div>
                    <h3 class="font-medium text-sm text-gray-900">Comment contacter le support ?</h3>
                </div>

                <div class="space-y-2">
                    <div class="flex items-center gap-3">
                        <span class="font-medium w-28 text-gray-600">Par Email:</span>
                        <a class="text-indigo-600 hover:underline" href="mailto:helpdesk@avsit.io">helpdesk&#64;avsit.io</a>
                    </div>
                    <div class="flex items-center gap-3">
                        <span class="font-medium w-28 text-gray-600">Par téléphone:</span>
                        <a class="text-indigo-600 hover:underline" href="tel:+3225855336">+32 2 585 53 36</a>
                    </div>
                </div>

                <div class="pt-2 border-t border-gray-100">
                    <p class="text-xs text-gray-500">
                        Vous pouvez contacter le support pour toute demande de fonctionnalité ou rapport de bug.
                    </p>
                    <p class="text-xs text-gray-500 mt-2">
                        Si vous signalez un problème, veuillez décrire la manière de le reproduire et si possible inclure des captures d'écran illustrant le problème.
                    </p>
                </div>
            </div>

            <!-- Footer actions -->
            <div class="flex items-center justify-between gap-2 px-4 py-3 border-t border-gray-100">
                <span class="text-xs text-gray-600">Version {{ appVersion }}</span>
                <button
                    type="button"
                    (click)="cancel()"
                    class="inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
}
